import { axiosInstance } from "./AxiosInterceptor";
import { backendConfig } from "../config/BackendConfig";

/**
 * @param {
 *  organizationId: <TenantId>,
 *  locationHierarchy: <TenantID> || <TenantID#SiteId> || <TenantID#SiteId#Level1>,
 *  requestedByUserId: userId
 * } queryParam
 * @returns Promise
 */
export const getLocationAndHierarchyDetails = (queryParam) => {
  /**End Point:- getLocationAndHierarchyDetails**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getLocations,
    queryParam
  );
};

export const updateLocation = (queryParam) => {
  /**End Point:- updateLocation**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.updateLocation,
    queryParam
  );
};

export const deleteLocation = (queryParam) => {
  /**End Point:- deleteLocation**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.deleteLocation,
    queryParam
  );
};

export const createLocation = (queryParam) => {
  /**End Point:- createLocation**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.createLocation,
    queryParam
  );
};


